const variantToThemeSchemeMap = {
  negative: 'dark',
  warning: 'light',
  informational: 'dark'
};

export { variantToThemeSchemeMap };
